<template>
  <div v-if="noInternetConnection" class="text-center" role="alert" style="position: fixed; bottom: 0; left: 0; right: 0; margin-bottom: 0; z-index: 9999999999;">
      <v-alert density="comfortable" class="alertStyle">
          <strong style="color:#721c24">No Internet Connection!</strong>
          <v-btn variant="flat" size="small" color="#424242" @click="reloadNow()" class="text-none ml-2">Reload now</v-btn>
      </v-alert>
  </div>
  <div v-if="latestVersion > config.version" class="text-center" role="alert" style="position: fixed; bottom: 0; left: 0; right: 0; margin-bottom: 0; z-index: 9999999999;">
      <v-alert density="comfortable" class="alertStyle">
          <strong style="color:#721c24">New version of CodeREADr is available!</strong>
          <v-btn variant="flat" size="small" color="#424242" @click="reloadNow()" class="text-none ml-2">Reload now</v-btn>
      </v-alert>
  </div>

</template>

<script setup lang="ts">

import {ref, onBeforeMount, onMounted} from "vue";
import {useRoute, useRouter} from "vue-router";
import Config from '../service/Config';
import EventManager from '../service/AppEventManagerService';
import flashMessenger from "../service/FlashMessenger";
import { useStore } from 'vuex';
import securityService from "../service/SecurityService";
import axios from "axios";

const route = ref<any>(useRoute());
const router = ref<any>(useRouter());
const store = ref(useStore());
const v = ref('0.0.0');
const config = ref(Config);
const eventManager = ref(EventManager);
const latestVersion = ref(config.value.version);
const username = ref<any>(store.value.getters.getAdminEmail);
const adminAccountId = ref();
const currentRouteName = ref();
const noInternetConnection = ref(false);
const isOwner = ref(null);
const me = ref();

onBeforeMount(async() => {
  eventManager.value.on('auth.signin' , async () => {
    await load();
  });
  eventManager.value.on('auth.signout-post', async ()=> {
    await checkUser();
    window.location.href = '/signin';
  });
})

onMounted(async() => {
  await load ();
})

async function load () {
  currentRouteName.value = router.value.currentRoute.path;
  setInterval(() => {
    flashMessenger.refresh();
  }, 500);
  store.value.subscribe((mutation:any, state:any) => {
    if (mutation.type == 'setAdminEmail') {
      username.value = state.adminEmail;
    }
  })
  me.value = await securityService.me();
  adminAccountId.value = me.value ? me.value.accountId: '';

  await checkUser();
  const versionChars = [];
  if (config.value.version < 100) {
    versionChars.push(0);
  }
  for (let c of config.value.version) {
    versionChars.push(c);
  }
  v.value = versionChars.join('.');

  let check = async () => {
    let ts = Math.round(new Date().getTime() / 1000);
    const response = await axios.get('version.json?t=' + ts);
    let version = response.data;
    latestVersion.value = version.current;
    if (version.min > config.value.version) {
      window.location.reload();
    }
  }
  await check();
  setInterval(check, 5 * 60 * 1000);

  window.addEventListener("offline", () => {
    noInternetConnection.value = true;
  }, false);

  window.addEventListener("online", () => {
    noInternetConnection.value = false;
  }, false);
}

async function checkUser() {
  const response = await securityService.getUser();
  if (!response || response.error) {
    me.value = null;
    config.value.crFormat = 'minimal';
  } else {
    me.value = response.admin[0];
    config.value.crFormat = 'normal';
    if (me.value.username != username.value) {
      store.value.commit('setAdminEmail', me.value.username);
    }
    isOwner.value = securityService.isOwner();
  }
}

function reloadNow() {
  window.location.reload();
}

</script>

<style scoped lang="scss">

.alertStyle {
  background-color: #f8d7da;
  border: 1px solid #f5c6cb;
}

</style>